var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "manager_dashboard" },
    [
      _c("user-menu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _vm.admin ? _c("admin-sidebar-menu") : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "content-wrapper" }, [
            _c(
              "div",
              { staticClass: "container-wrapper center" },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "heading-seperator" }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "margin-bottom-10",
                  staticStyle: { clear: "both" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.loading,
                        expression: "loading"
                      }
                    ],
                    staticClass: "loading_show"
                  },
                  [_c("div", { staticClass: "spinner-border text-danger" })]
                ),
                _vm._v(" "),
                _vm._l(_vm.account_lists, function(account_list) {
                  return _c(
                    "div",
                    {
                      staticClass: "dash_container_wrapper col-lg-12 float-left"
                    },
                    [
                      _c("div", { staticClass: "account_link " }, [
                        account_list.school_flag == 1
                          ? _c(
                              "span",
                              {
                                staticClass: "cursor-pointer",
                                on: {
                                  click: function($event) {
                                    return _vm.setUserAccount(
                                      account_list.id,
                                      "/student-account-tasklists/"
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(account_list.company_name) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        account_list.school_flag == 0
                          ? _c(
                              "span",
                              {
                                staticClass: "cursor-pointer",
                                on: {
                                  click: function($event) {
                                    return _vm.setUserAccount(
                                      account_list.id,
                                      "/mentee-account-tasklists/"
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(account_list.company_name) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "fa fa-angle-right float-right font-20",
                          staticStyle: { "padding-top": "5px" },
                          attrs: { "aria-hidden": "true" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticStyle: { clear: "both" } })
                    ]
                  )
                }),
                _vm._v(" "),
                _c("div", { staticStyle: { clear: "both" } })
              ],
              2
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h3", { staticClass: "d-inline heading" }, [_vm._v("Account")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-520220dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-520220dc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/student/student_dashboard.vue
// module id = null
// module chunks = 